<li class="list-item btn">
    <h3>{{item.login}}</h3>
    <p>{{#if item.isMain}}{{msg 'thm.ui.common.infopanel.customer.EditSourceCustomerPopup.mainUser'}}{{/if}}</p>
</li>